function Help(){

    return<>
    <div className="container mt-4" style={{marginBottom:'50px'}}>
  <div className="row d-flex justify-content-center">
    <div className="col-md-9" >
      <div className="card p-4 mt-3" style={{boxShadow:'2px 2px 15px rgba(0,0,0,0.3)'}}>
        <h3 className="heading mt-5 text-center">Hi! How can we help You?</h3>
        <div className="d-flex justify-content-center px-5">
          <div className="search">
            <input style={{border:'1px solid #536BF6',padding:'5px',borderRadius:'10px',height:'40px'}} type="text" className="search-input" placeholder="Search..." name="" />
            <a href="#" style={{height:'25px',marginRight:'10px',marginBottom:'20px'}} className="search-icon">
              <i className="fa fa-search"></i>
            </a>
          </div>
        </div>
        <div className="row mt-4 g-1 px-4 mb-5">
          <div className="col-md-2">
            <div className="card-inner p-3 d-flex flex-column align-items-center">
              <img src="https://i.imgur.com/Mb8kaPV.png" width="50" alt="" />
              <div className="text-center mg-text">
                <span className="mg-text">Account</span>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card-inner p-3 d-flex flex-column align-items-center">
              <img src="https://i.imgur.com/ueLEPGq.png" width="50" alt="" />
              <div className="text-center mg-text">
                <span className="mg-text">Payments</span>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card-inner p-3 d-flex flex-column align-items-center">
              <img src="https://i.imgur.com/tmqv0Eq.png" width="50" alt="" />
              <div className="text-center mg-text">
                <span className="mg-text">Delivery</span>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card-inner p-3 d-flex flex-column align-items-center">
              <img src="https://i.imgur.com/D0Sm15i.png" width="50" alt="" />
              <div className="text-center mg-text">
                <span className="mg-text">Product</span>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card-inner p-3 d-flex flex-column align-items-center">
              <img src="https://i.imgur.com/Z7BJ8Po.png" width="50" alt="" />
              <div className="text-center mg-text">
                <span className="mg-text">Return</span>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card-inner p-3 d-flex flex-column align-items-center">
              <img src="https://i.imgur.com/YLsQrn3.png" width="50" alt="" />
              <div className="text-center mg-text">
                <span className="mg-text">Guarantee</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style={{width:'100%',marginTop:'50px'}}><iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Nike%20Store+(Your%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/sport-gps/">swimming watch</a></iframe></div>
</div>

    </>

}export default Help;